import { ActivatedRoute, Params } from '@angular/router';

export class AppSingle {

  id: string;
  protected categoryId: string;
  protected companyId: string;
  protected who: string;
  protected signaturePosition: string;
  tipo: string;

  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.id = params['id'];
      }
      if (params['categoryId']) {
        this.categoryId = params['categoryId'];
      }
      if (params['companyId']) {
        this.companyId = params['companyId'];
      }
      if (params['who']) {
        this.who = params['who'];
      }
      if (params['signaturePosition']) {
        this.signaturePosition = params['signaturePosition'];
      }
      if (params['tipo']) {
        this.tipo = params['tipo'];
      }
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app-single.ts